import { render } from "./user_icon.vue?vue&type=template&id=52eb10a5&scoped=true"
import script from "./user_icon.vue?vue&type=script&lang=js"
export * from "./user_icon.vue?vue&type=script&lang=js"

import "./user_icon.vue?vue&type=style&index=0&id=52eb10a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eb10a5"]])

export default __exports__